var map = {
	"./app-store-badge.svg": 1207,
	"./google-play-badge.svg": 1208,
	"./zola_registry_app_icon.png": 1209,
	"./zola_registry_app_icon@2x.png": 1210,
	"./zola_weddings_app_icon.png": 1211,
	"./zola_weddings_app_icon@2x.png": 1212,
	"./zola_weddings_app_icon_android.png": 1213,
	"./zola_weddings_app_icon_android@2x.png": 1214
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1206;


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/footer nonrecursive \.(jpg|jpeg|png|gif|svg)(\?.*)?$
// module id = 1206
// module chunks = 40